module SelectTools {
	export function addBlankOption(element: JQuery<HTMLElement>) {
		element.append("<option></option>");
	}

	export function selectNonBlankOptionIfOnlyOne(element: JQuery<HTMLElement>) {
		const nonNullOption = element.children("option:not(:empty)");
		if (nonNullOption.length === 1) {
			ValTools.valWithChange(element, nonNullOption.val());
		}
	}

	export function selectDefaultOption(element: JQuery<HTMLElement>) {
		const defaultOption = element.data("default");
		if (defaultOption != undefined) {
			ValTools.valWithChange(element, defaultOption);
		}
	}

	export function autoSelect(element: JQuery<HTMLElement>) {
		selectDefaultOption(element);
		selectNonBlankOptionIfOnlyOne(element);
	}

	export function initDataApi() {
		//$("select").each((index, element) => {
		//	const el = $(element as any);
		//	selectNonBlankOptionIfOnlyOne(el);
		//	selectDefaultOption(el);
		//});
	}
}